__turbopack_context__.v({
  "fallback_ui": "FallbackUI-module-scss-module__82LzTG__fallback_ui",
  "message": "FallbackUI-module-scss-module__82LzTG__message",
});
